<template>
    <div v-if="loaded">
        <div v-for="(message, index) in messages" :key="index" class="message" v-bind:class="{ reply: message.is_reply }">
            <div class="message__title">
                <h3>{{ message.title }}</h3>
                <span>{{ message.submitted_at | submittedAt }}</span>
            </div>
            <nl2br tag="p" :text="message.body" />
        </div>

        <div v-if="noMessages">
            <p v-if="config.localeApp == 'se'">
                Dus eai leat dieđáhusat iežat boastakássas.<br />
                Dieđáhusat mat leat boarraset go 14 beaivvi sihkkojuvvojit automáhtalaččat.
            </p>
            <p v-else>
                Du har ingen meldinger i postkassen din.<br />
                Husk at meldinger eldre enn 14 dager blir automatisk slettet.
            </p>
        </div>
    </div>
</template>
<script>
import { config } from '../../volunteer/config/config';
import moment from 'moment';
import Nl2br from 'vue-nl2br';

export default {
    components: {
        Nl2br,
    },
    data() {
        return {
            loaded: false,
            messages: [],
            config: config,
        };
    },
    computed: {
        noMessages() {
            return this.messages.length == 0;
        },
    },
    created() {
        this.fetchMessages();
    },
    filters: {
        submittedAt: function(value) {
            var now = moment();
            var submitted = moment(value);
            var diff = now.valueOf() - submitted.valueOf();
            if (config.locale != 'se' && diff < 86400000 * 2) {
                // 1000*60*60*2 * 2
                return submitted.calendar();
            } else {
                return submitted.format('DD.MM.YY HH:mm');
            }
        },
    },
    methods: {
        fetchMessages() {
            var _this = this;
            this.$http({ method: 'get', url: 'messages' })
                .then(function(response) {
                    if (response && response.data) {
                        _this.messages = response.data;
                        _this.loaded = true;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
    },
};
</script>
<style lang="scss">
.message__title {
    display: flex;
    justify-content: center;

    h3 {
        //color: $primary-color;
    }

    span {
        columns: #b0aeb6;
        margin-left: auto;
        font-style: italic;
    }
}
.message + .message {
    padding-top: rem-calc(24);
}
.reply {
    border-left: 3px solid #b0aeb6;
    padding: rem-calc(20 0 20 20);

    h3 {
        font-style: italic;
    }
    p {
        font-style: italic;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue